<template>
    <div class="container md:mt-64 mt-10 flex justify-between items-center mx-auto px-8 md:px-14 lg:px-24 w-full" id="experience">
            <section class="w-full">
                <h2 id="" class="secondary-title">Experience</h2>  
                <!-- Companies -->
                <div class="space-y-12 mt-10">
                    <div class="w-full p-16 lg:px-30 lg:py-20 lg:space-x-24 flex justify-center lg:justify-start flex-wrap lg:flex-nowrap">
                        <div class="mb-6 lg:mb-0">
                            <img src="@/img/deadia.png" alt="" class="rounded-md">
                        </div>
                        <div class="flex flex-wrap justify-center text-center lg:text-left lg:block">
                            <h3 class="text-3xl font-semibold">Junior Programmer(DeaDia Alimentos)</h3>
                            <div class="w-full lg:w-auto flex flex-wrap justify-center lg:justify-start gap-3 mt-6 mb-8">
                                <div class="badge text-white">January 2022 - August 2022</div>
                            </div>
                            <p class="text-secondary text-justify">In this time I created Crud systems for process controls, investments, sales, etc, I did it using the following tools php, vue, javascript, tailwind css.</p>
                        </div>
    
                    </div>
                    <div class="w-full p-16 lg:px-32 lg:py-20 lg:space-x-36 flex justify-center lg:justify-start flex-wrap lg:flex-nowrap">
                        
                        <!-- Company logo -->
                        <div class="mb-6 lg:mb-0">
                            <img src="@/img/pequivenLogo.png" alt="PequivenLogo" class="rounded-md">
                        </div>
    
                        <!-- Company info -->
                        <div class="flex flex-wrap justify-center text-center lg:text-left lg:block">
                            <h3 class="text-3xl font-semibold">IT Intern (Pequiven)</h3>
                            <div class="w-full lg:w-auto flex flex-wrap justify-center lg:justify-start gap-3 mt-6 mb-8">
                                <div class="badge text-white">September 2022 - April 2023</div>
                            </div>    
                            <p class="text-secondary text-justify">During my stay I updated and created systems for the company, the systems are required by other areas so everything is done by intranet working with tools like php, javascript, bootstrap, ssh, API Rest, postman, webmin, among others.</p>
                        </div>
    
                    </div>

                    <div class="w-full p-16 lg:px-32 lg:py-20 lg:space-x-36 flex justify-center lg:justify-start flex-wrap lg:flex-nowrap">
                        
                        <!-- Company logo -->
                        <div class="mb-6 lg:mb-0">
                            <img src="@/img/leadbox.jpeg" alt="leadboxLogo" class="rounded-md">
                        </div>
    
                        <!-- Company info -->
                        <div class="flex flex-wrap justify-center text-center lg:text-left lg:block">
                            <h3 class="text-3xl font-semibold">Frontend Developer (Leadbox)</h3>
                            <div class="w-full lg:w-auto flex flex-wrap justify-center lg:justify-start gap-3 mt-6 mb-8">
                                <div class="badge text-white">May 2024 - Current</div>
                            </div>    
                            <p class="text-secondary text-justify">Provides technical support to the websites of various clients among which are canada dealers of brands such as ford, hyundai, honda, general motors, among others, using tools such as vue js, javascript, php, laravel, wordpress.</p>
                        </div>
    
                    </div>

                </div>
    
            </section>
        </div>
    </template>
    
    <script>
    export default {
    
    }
    </script>
    
    <style>
    
    </style>